module.exports = {
  "country": "AM",
  "artist": "Ladaniva",
  "song": "Jako",
  "year": "2024",
  "place": "8",
  "spotify": "2MiEtw8UquKvxOwu47oTMu"
};